var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "div",
    },
    [
      _c(
        "div",
        { staticClass: "div-top" },
        [
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-plus", type: "primary" },
              on: { click: _vm.handleAdd },
            },
            [_vm._v("新建货位")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                icon: "el-icon-minus",
                type: "danger",
                disabled: _vm.selectedRows.length === 0,
              },
              on: {
                click: function ($event) {
                  return _vm.handleDetele(_vm.selectedRows)
                },
              },
            },
            [_vm._v("删除")]
          ),
          _c("el-input", {
            staticStyle: { width: "300px", "margin-left": "10px" },
            attrs: { placeholder: "请输入货位编号或名称", clearable: "" },
            model: {
              value: _vm.searchData.Keyword,
              callback: function ($$v) {
                _vm.$set(_vm.searchData, "Keyword", $$v)
              },
              expression: "searchData.Keyword",
            },
          }),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "10px" },
              attrs: { type: "primary" },
              on: { click: _vm.handleSearch },
            },
            [_vm._v("查询")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "div-center" },
        [
          _c(
            "el-table",
            {
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, height: "calc(100% - 40px)" },
              on: { "selection-change": _vm.handleSelect },
            },
            [
              _c("el-table-column", {
                attrs: { label: "", width: "50", type: "selection" },
              }),
              _c("el-table-column", {
                attrs: { label: "序号", width: "50", type: "index" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "货位编号",
                  align: "center",
                  prop: "Code",
                  sortable: "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "货位名称",
                  align: "center",
                  prop: "Name",
                  sortable: "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "库区",
                  align: "center",
                  prop: "PB_StorArea.Name",
                  sortable: "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "货架",
                  align: "center",
                  prop: "PB_Rack.Name",
                  sortable: "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "状态",
                  align: "center",
                  prop: "IsForbid",
                  sortable: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.IsForbid
                          ? _c("el-tag", [_vm._v("启用")])
                          : _c("el-tag", { attrs: { type: "danger" } }, [
                              _vm._v("禁用"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: { color: "#f78989" },
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDetele([scope.row])
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                height: "40px",
                display: "flex",
                "align-items": "center",
                "justify-content": "right",
              },
            },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pagination.PageIndex,
                  "page-sizes": _vm.pagination.PageSizes,
                  "page-size": _vm.pagination.PageRows,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.pagination.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("EditForm", { ref: "EditForm", on: { success: _vm.handleSearch } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }